import { Button } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { selectLang } from '../../../Contexts/lang/langueSlice';
import {getStatusCraLabel } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, sortDate } from '../../../Utils/utils';
import { navigate2CraCraX } from '../../Admin/Mission/AllCraAdmin';

const AllCraClient = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const { i18n } = useTranslation();
    const lang = useSelector(selectLang);
    const role = useRole();
    const { setBackdropOpen } = useUtilities();

    const craColumnsClient = [
        {
            field: 'noCra',
            title: i18n.t('Réf.CRA'),
            render: (rowData) => (
                <Button
                    variant="text"
                    onClick={() => navigate2CraCraX({rowData, role,lang,isEsn:(role=='esn' ? true:false),isAchat:(role=='esn' ? true:false), navigate})}
                >
                    {rowData?.noCra}
                </Button>
            ),
        },
        {
            field: 'intituleMission',
            title: i18n.t('Intitulé de la mission'),
        },
        {
            field: 'statutCraFinal',
            title: i18n.t('Statut du CRA'),
            render:  rowData =>
                i18n.t(rowData?.statutCraFinal)
            // render:  rowData => (
            //     <>
            //         {getStatusCraLabel(rowData?.statutCra)}
            //     </>
            // )
        },

        {
            field: 'refExpert',
            title: i18n.t('Réf Expert'),
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom Expert'),
        },
        {
            field: 'dateValidationExpert',
            title: i18n.t('Date de validation/Expert'),

        },
        {
            field: 'dateValidationClient',
            title: i18n.t('Date de validation/Client'),

        },
        {
            field: 'date',
            title: i18n.t('Période'),
            //render: rowData =>{
            //    return (searchLabelInEnumByValue(MonthsString, (rowData?.month)));
            //}
        },
        //{
        //    field: 'year',
        //    title: i18n.t('Année',
        //    //lookup: { 2023: '2023', 2022: '2022' },

        //},
        {
            field: 'nbJour',
            title: i18n.t('Nb jours validés'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJour,'j');
            }

        },
        {
            field: 'nbrJrsRestants',
            title: i18n.t('Nb.j. restants'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbrJrsRestants,'j');
            }
        },
        {
            field: 'tjClient',
            title: i18n.t('Taux journalier HT'),
            render: rowData =>
                addEuro4Decimal(rowData?.tjClient)
        },
        {
            field: 'totalAstreintes',
            title: i18n.t('Total Astreintes'),
            render: rowData =>
                addEuro4Decimal(rowData?.totalAstreintes)
        },
        {
            field: 'totalHno',
            title: i18n.t('Total HNO'),
            render: rowData =>
                addEuro4Decimal(rowData?.totalHno)
        },
        {
            field: 'totalNotesFrais',
            title: i18n.t('Total notes de frais'),
            render: rowData =>
                addEuro4Decimal(rowData?.totalNotesFrais)
        },
        {
            field: 'totalHtClient',
            title: i18n.t('Total HT'),
            render: rowData =>
                addEuro4Decimal(rowData?.totalHtClient)
        },

    ];

    //=============================================================================
    let navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [url, setUrl] = useState('');
    const [filtreCraAvalider, setFiltreCraAvalider] = useState(searchParams.get('filtreCraAvalider') === 'true');
    const [craRows, setCraRows] = React.useState();

    useEffect(() => {
        if (role)
            getMyCras();
    }, [role]);

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtrecraavalider') ){
            setFiltreCraAvalider(false);
        }
    }, [url]);

    useEffect(() => {
        getMyCras();
    }, [filtreCraAvalider]);

    const mapCRA = (cra,nbrJrsRestants) => {
        let craType = cra?.statutCraX ? 'CRAX' : 'CRA';

        return (
            {
                'craType': craType,
                'noCra': craType == 'CRAX' ? cra?.craXId : cra?.craId,
                'intituleMission': cra?.missionId?.titre,
                'statutCraFinal': getStatusCraLabel(cra?.statutCra || cra?.statutCraX),
                'dateValidationExpert': formatDateJJMMYYYY(cra?.DateVE),
                'dateValidationClient': formatDateJJMMYYYY(cra?.DateVC),
                'Date':new Date(cra?.year, cra?.month - 1),
                'nbrJrsRestants':nbrJrsRestants,
                //formatDateJJMMYYYY(facture?.craId?.DateVE) - formatDateJJMMYYYY(facture?.craId?.DateVC)
                'date':
                    dayjs(new Date(cra?.year, cra?.month - 1))
                        .locale('fr')
                        .format('MMMM YYYY'),
                'nbJour': cra?.nbrDays,
                'tjClient':cra?.tjClient,
                'totalHtClient': cra?.nbrDays ? (Number(cra?.nbrDays) * cra?.tjClient)
                    : cra?.montantTotalClient,
                // /? Cra X
                'totalAstreintes': cra?.totalAstreintes,
                'totalHno': cra?.totalHnosClient,
                'totalNotesFrais': cra?.totalNotesFrais ,
                // ? son't les colonnes qui controle l'affichage
                'refClient': cra?.missionId?.companyDataId?.clientId ?? cra?.missionId?.esnId?.esnId,
                'nomClient': cra?.missionId?.companyDataId?.profileEntreprise?.nom ?? cra?.missionId?.esnId?.profileEntreprise?.nom,
                'refExpert': cra?.missionId?.expertId?.expertId,
                'nomExpert': getNomPrenomClearFromPersoData(cra?.missionId?.expertId?.persoData),
                ...cra
            }
        );
    };
    //=================================================================
    const getMyCras = async () => {
        setBackdropOpen(true);
        try {
            const response = await axiosPrivate.get(`/cra/getMyCras/${(role === 'esn' && !location.pathname.includes('AllCrasVente')) ? '?isAchat=true' : ''}`, { // PSS::::faut ajouter la condition selon location.pathname
                // signal: controller.signal
            });

            let listCra = await response.data?.cras;
            let processedBdcIds =[];
            let tempArray = [];
            let nbrJrsRestants=0;
            listCra?.forEach(cra => {
                nbrJrsRestants=cra?.bdcId?.nbJoursBDC;
                if(filtreCraAvalider==true){
                    if((cra?.statutCra=='VE' || cra?.statutCraX=='VE') && !processedBdcIds.includes(cra?.bdcId?.bdcId)){
                        processedBdcIds.push(cra?.bdcId?.bdcId);
                        // Iterate through listCra to adjust nbrJrsRestants for matching bdcId
                        listCra?.forEach(prevCra => {
                            if (prevCra?.bdcId?.bdcId === cra?.bdcId?.bdcId && (prevCra?.statutCra=='VE' || prevCra?.statutCraX=='VE')) {
                                // Create the cra2Push object for the matching item
                                nbrJrsRestants =  nbrJrsRestants - (prevCra?.nbrDays ?? 0);
                                tempArray.push(mapCRA(prevCra,nbrJrsRestants));
                            }
                        });
                    }
                }
                else{
                    if(!processedBdcIds.includes(cra?.bdcId?.bdcId)){
                        processedBdcIds.push(cra?.bdcId?.bdcId);
                        listCra?.forEach(prevCra => {
                            if (prevCra?.bdcId?.bdcId === cra?.bdcId?.bdcId ) {
                                // Create the cra2Push object for the matching item
                                nbrJrsRestants =  nbrJrsRestants - (prevCra?.nbrDays ?? 0);
                                tempArray.push(mapCRA(prevCra,nbrJrsRestants));
                            }
                        });
                    }

                }
            });

            tempArray = sortDate(tempArray.reverse());
            setCraRows(tempArray);

        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };
    const [selectedRow, setSelectedRow] = React.useState(null);

    return (
        <>
            <div className='frame5Profile'>
                {i18n.t('CRA & Factures')}
                {role === 'esn' && (
                    <>
                        &gt;
                        <span style={{ color: '#B0B0B0' }}>{i18n.t('Achat')}</span>
                    </>
                )}
                &gt;
                <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Liste des CRA')}</span>
            </div>

            <div className='HomeFrame'>
                <h4 className='titlesociete'>
                    {i18n.t('Liste des CRA')}
                </h4>

                <MaterialTableComponent
                    data={craRows}
                    columns={craColumnsClient}
                    title="CRA"
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                        // setRowSelected(rowData);
                        //console.log(rowData);
                        //if (rowData?.craType == 'CRAX') {
                        //    console.log({ rowData });
                        //    navigate(`/${role}/CraX/${rowData?._id}`,
                        //        //* some infos for the expert update
                        //        { state: rowData }
                        //    );
                        //}
                        //else if (rowData?.craType == 'CRA') {
                        //    navigate(`/${role}/Cra/${rowData?._id}`,);
                        //}
                    }}
                    selectedRow={selectedRow}
                //options={{filtering: true}}
                />
            </div>
        </>
    );
};

export default AllCraClient;